import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import PressReleaseSection from '../Components/insights/PressReleaseSection'

function InsightsDetail() {
    return (
        <div>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/insights/bg2.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    {/* Responsive Gradient: Mobile par niche se upar, Desktop par left se right */}
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                {/* Content Container */}
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] lg:max-w-[973px] mt-auto md:mt-0">
                        <p className="text-[#FFFFFF] max-w-[973px] w-full text-[20px] md:text-[30px] leading-[1.4] md:leading-[34px] lg:leading-[54px] font-sora font-[600] tracking-wider text-left opacity-90 lg:opacity-100">
                            Mobikode Announces the Acquisition of Avant Techno Solutions to Expand Payment Modernization and Wealth Management Capabilities
                        </p>
                    </div>
                </div>
            </section>
            <PressReleaseSection />
        </div>
    )
}

export default InsightsDetail
